import React, { FunctionComponent } from "react"
import { iExhibition } from "../../definitions"
import { eImageVersions } from "../../definitions/Image"
import { useImageUrl } from "../../hooks/useImageUrl"
import "./ExhibitionLoader.css"
import "react-slideshow-image/dist/styles.css"
import Gallery from "../Gallery"
import { Zoom } from "react-slideshow-image"
import { isMobile } from "react-device-detect"

const fadeImagesMobile = [
  {
    image: window.location.origin + "/loadingImages/phone_rotate.png",
  },
  {
    image:
      window.location.origin + "/loadingImages/phone_zoom_in_out_pinch.png",
  },
  {
    image: window.location.origin + "/loadingImages/phone_zoom_in_out_tap.png",
  },
  {
    image: window.location.origin + "/loadingImages/phone_info_point.png",
  },
]

const fadeImages = [
  {
    image: window.location.origin + "/loadingImages/desktop_zoom_01.png",
  },
  {
    image: window.location.origin + "/loadingImages/desktop_rotate_02.png",
  },
  {
    image: window.location.origin + "/loadingImages/desktop_info point_03.png",
  },
]

interface iProps {
  exhibition?: iExhibition
  progress: number
}

const ExhibitionLoader: FunctionComponent<iProps> = ({
  exhibition,
  progress,
}) => {
  const imageUrl = useImageUrl(
    eImageVersions.LWRegular,
    exhibition?.screenshots && exhibition?.screenshots[0],
  )

  const blur = (10 - progress * 10).toFixed(2)

  return (
    <div className="exhibition-loader">
      <div
        className="background"
        style={{
          backgroundImage: `url(${imageUrl})`,
          filter: `blur(${blur}px)`,
        }}
      ></div>
      <div className="wrapper-holder">
        <div className="tutorial-wrapper">
          {isMobile ? (
            <Zoom
              autoplay={true}
              indicators={true}
              duration={3000}
              transitionDuration={500}
              pauseOnHover={true}
              arrows={false}
              defaultIndex={0}
              canSwipe={true}
              // scale={0.5}
            >
              <div className="each-fade">
                <div className="image-container">
                  <img src={fadeImagesMobile[0].image} />
                </div>
              </div>
              <div className="each-fade">
                <div className="image-container">
                  <img src={fadeImagesMobile[1].image} />
                </div>
              </div>
              <div className="each-fade">
                <div className="image-container">
                  <img src={fadeImagesMobile[2].image} />
                </div>
              </div>
              <div className="each-fade">
                <div className="image-container">
                  <img src={fadeImagesMobile[3].image} />
                </div>
              </div>
            </Zoom>
          ) : (
            <Zoom
              autoplay={true}
              indicators={true}
              duration={3000}
              transitionDuration={500}
              pauseOnHover={true}
              arrows={false}
              defaultIndex={0}
              canSwipe={true}
              scale={1.5}
            >
              <div className="each-fade">
                <div className="image-container">
                  <img src={fadeImages[0].image} />
                </div>
              </div>
              <div className="each-fade">
                <div className="image-container">
                  <img src={fadeImages[1].image} />
                </div>
              </div>
              <div className="each-fade">
                <div className="image-container">
                  <img src={fadeImages[2].image} />
                </div>
              </div>
            </Zoom>
          )}
        </div>

        <div className="loader-wrapper">
          <div className="exhibition-title">Loading interactive 3D model</div>
          <div className="exhibition-wait">Please wait</div>
          <div className="lds-spinner">
            {/* <img
              src={window.location.origin + "/loadingImages/loading-icon.png"}
            /> */}
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ExhibitionLoader
